import { QueryParams } from "./CommonUtils/constants";

const useParamValues = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const teacherId = urlParams.get(QueryParams.TEACHER_ID);
  const studentName = urlParams.get(QueryParams.STUDENT_NAME);
  const studentId = urlParams.get(QueryParams.STUDENT_ID);
  const classNum = urlParams.get(QueryParams.CLASS);
  const section = urlParams.get(QueryParams.SECTION).toUpperCase();
  const schoolId = urlParams.get(QueryParams.SCHOOL_ID);
  const subjectId = urlParams.get(QueryParams.SUBJECT_ID);
  const token = urlParams.get(QueryParams.TOKEN);
  const organisation = urlParams.get(QueryParams.ORGANISATION);
  const studentIds = urlParams.get(QueryParams.STUDENT_IDS);
  const externalAssessmentId = urlParams.get(QueryParams.STATE_ASSESSMENT_ID);

  return {
    teacherId,
    studentName,
    studentId,
    classNum,
    section,
    schoolId,
    subjectId,
    token,
    organisation,
    studentIds,
    externalAssessmentId,
  };
};

export default useParamValues;
